import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { SortDirection } from '@scio3/shared-types';
import { SORT_DIRECTION } from '@scio3/shared-types';

export type ScheduleSortField = 'name' | 'createdAt' | 'lastUpdatedDate';
export type FolderMode = 'on-top' | 'mixed';

interface ScheduleSortState {
  sortField: ScheduleSortField;
  sortDirection: SortDirection;
  folderMode: FolderMode;
  setSort: (field: ScheduleSortField, direction: SortDirection) => void;
  setSortField: (field: ScheduleSortField) => void;
  setSortDirection: (direction: SortDirection) => void;
  setFolderMode: (mode: FolderMode) => void;
}

export const useScheduleSortStore = create<ScheduleSortState>()(
  persist(
    (set) => ({
      sortField: 'lastUpdatedDate',
      sortDirection: SORT_DIRECTION.DESC,
      folderMode: 'on-top',
      setSort: (sortField, sortDirection) => set({ sortField, sortDirection }),
      setSortField: (sortField) => set({ sortField }),
      setSortDirection: (sortDirection) => set({ sortDirection }),
      setFolderMode: (folderMode) => set({ folderMode }),
    }),
    { name: 'schedule-sort-store' },
  ),
);
